var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSliderNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#102A56",
  strokeWidth: 2,
  d: "M23.25 44.705c12.012 0 21.75-9.738 21.75-21.75s-9.738-21.75-21.75-21.75S1.5 10.943 1.5 22.955s9.738 21.75 21.75 21.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#102A56",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19.273 14.184 8.693 8.693-8.693 8.693"
})));
export default SvgSliderNext;